"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToHslColor = exports.TagGroup = exports.Tag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = require("./theme");
var _excluded = ["children", "list"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TagWrapper = (0, _styledComponents["default"])("div").attrs({
  className: 'flexi-tag'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  overflow: hidden;\n  align-items: center;\n  font-family: ", ";\n  height: ", "px;\n  border: 1px solid ", "; \n  background-color: ", ";\n  padding: ", ";\n  color: ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  transition: ", ";\n  ", "\n  ", "\n  ", "\n    ", "\n    ", "\n\n  &:hover{\n    background-color: ", "; \n  }\n\n  ", "\n\n  & .flexi-tag-center{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n  }\n  \n  ", "\n    &.flexi-tag-counter{\n    position: relative;\n    overflow: visible;\n    margin-left: 5px;\n    &:after{\n      content: '';\n      display: block;\n      position: absolute;\n      top: calc(50%-1px);\n      height: 2px;\n      width: 5px;\n      left: -5px;\n      background: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.PrimaryFont;
}, function (props) {
  return props.height;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return (0, _polished.transparentize)(0.8, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.pad;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.round ? "".concat(props.height / 2, "px") : props.theme.PrimaryRadius;
}, function (props) {
  return props.font ? props.font : props.theme.PrimaryFontSize;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.small && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-size: 10px;\n      height: 28px;\n    "])));
}, function (props) {
  return props.block && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      display: block;\n    "])));
}, function (props) {
  return props.dashed && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      border-style: dashed;\n    "])));
}, function (props) {
  return props.spaceLeft && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "])), function (props) {
    return props.spaceLeft.length >= 3 ? props.spaceLeft : "10px";
  });
}, function (props) {
  return props.spaceRight && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        margin-right: ", ";\n      "])), function (props) {
    return props.spaceRight.length >= 3 ? props.spaceRight : "10px";
  });
}, function (props) {
  return (0, _polished.transparentize)(0.7, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.solid && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      border: none;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border: none;\n        background: ", ";\n      }\n    "])), function (props) {
    return props.fontColor ? props.fontColor : "#fff";
  }, function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return (0, _polished.darken)(0.05, props.color ? props.color : props.theme.PrimaryColor);
  });
}, function (props) {
  return props.onClose && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      padding-right: 0;\n\n      & .flexisaf-tag-close {\n        flex-grow: 0;\n        cursor: pointer;\n        color: ", ";\n        width: ", "px;\n        height: ", "px;\n        border-radius: ", ";\n        background-color: #fff;\n        font-size: ", ";\n        line-height: ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: ", "px;\n        font-weight: bold;\n        transition: ", ";\n\n        &:hover {\n          color: ", ";\n        }\n      }\n      ", "\n    "])), function (props) {
    return props.color ? props.color : props.theme.PrimaryColor;
  }, function (props) {
    return props.height / 2;
  }, function (props) {
    return props.height / 2;
  }, function (props) {
    return props.round ? "".concat(props.height / 2, "px") : props.theme.PrimaryRadius;
  }, function (props) {
    return props.font ? props.font : props.theme.PrimaryFontSize;
  }, function (props) {
    return props.font ? props.font : props.theme.PrimaryFontSize;
  }, function (props) {
    return props.height / 4;
  }, function (props) {
    return props.theme.PrimaryTransition;
  }, function (props) {
    return (0, _polished.darken)(0.4, props.color ? props.color : props.theme.PrimaryColor);
  }, function (props) {
    return props.animate && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      .flexisaf-tag-close{\n          opacity: 0;\n          transform: translateX(-10px);\n        }\n      &:hover{\n        .flexisaf-tag-close{\n          opacity: 1;\n          transform: translateX(0px);\n        }\n      }\n      "])));
  });
}, function (props) {
  return props.color;
});
var stringToHslColor = function stringToHslColor() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var h = hash % 360;
  h = h < 0 ? h * -1 : h;
  return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
};
exports.stringToHslColor = stringToHslColor;
var Tag = function Tag(props) {
  var children = props.children,
    color = props.color,
    autocolor = props.autocolor;
  if (autocolor && typeof children === 'string') {
    color = stringToHslColor(children);
  }
  return /*#__PURE__*/_react["default"].createElement(TagWrapper, _extends({}, props, {
    color: "".concat(color)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-tag-center"
  }, children), props.onClose && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexisaf-tag-close",
    onClick: props.onClose
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-cancel"
  })));
};
exports.Tag = Tag;
Tag.defaultProps = {
  color: _theme.FlexTheme.PrimaryColor,
  block: false,
  spaceLeft: false,
  spaceRight: false,
  dashed: false,
  round: true,
  height: 30,
  pad: "0 15px",
  solid: false,
  small: false,
  autocolor: false
};
Tag.propTypes = {
  block: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  spaceLeft: _propTypes["default"].any,
  spaceRight: _propTypes["default"].any,
  dashed: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  height: _propTypes["default"].number,
  fontColor: _propTypes["default"].string,
  round: _propTypes["default"].bool,
  pad: _propTypes["default"].string,
  font: _propTypes["default"].number,
  solid: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  animate: _propTypes["default"].bool,
  autocolor: _propTypes["default"].bool
};
var TagGroupWrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  height: auto;\n  overflow: visible;\n  margin: 0;\n  padding: 0;\n\n  & .flexi-tag-group-container{\n    background: #fff;\n    ", "\n    border-radius: ", ";\n    padding: 5px;\n    min-height: 40px;\n    display: inline-block;\n    pointer-events: none;\n    position: absolute;\n    white-space: nowrap;\n    top: 40px;\n    ", ";\n    left: 0;\n    transition: opacity ease-out 0.3s, transform ease-out 0.3s;\n    z-index: 3;\n    opacity: 0;\n    transform: translateY(-10px);  \n\n    & .flexi-tag{\n      margin: 5px;\n    }\n  }\n  & .flexi-tag-group-activator{\n    display: inline-block;\n    white-space: nowrap;\n  }\n\n  ", "\n"])), function (props) {
  return props.solid && (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      background: ", ";\n    "])), function (props) {
    return props.theme.PrimaryGreyDark;
  });
}, function (props) {
  return props.round ? "".concat(props.height / 2, "px") : props.theme.PrimaryRadius;
}, function (props) {
  return props.theme.Elevate.high;
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  & .flexi-tag-group-container{\n      display: inline-block;\n      opacity: 1;\n      transform: translateY(0px);\n    }\n  "])));
});
var TagGroup = function TagGroup(props) {
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    listMap = _useState2[0],
    setList = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inView = _useState4[0],
    setInView = _useState4[1];
  (0, _react.useEffect)(function () {
    setList(props.list);
  }, [props.list]);
  var children = props.children,
    list = props.list,
    rest = _objectWithoutProperties(props, _excluded);
  var myChildren = [];
  if (props.children) {
    myChildren = !Array.isArray(children) ? [children] : children;
  }
  var countcolor = props.countcolor ? props.countcolor : children ? myChildren[0].props.color : props.autocolor ? stringToHslColor(listMap[0]) : _theme.FlexTheme.PrimaryColor;
  return /*#__PURE__*/_react["default"].createElement(TagGroupWrapper, _extends({}, props, {
    active: inView
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-tag-group-activator",
    onMouseEnter: function onMouseEnter() {
      return setInView(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInView(false);
    }
  }, children ? /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, myChildren[0].props, {
    spaceLeft: "0px",
    spaceRight: "0px"
  })) : /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    spaceLeft: "0px"
  }, rest, {
    spaceRight: "0px"
  }), listMap[0]), /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    className: "flexi-tag-counter"
  }, rest, {
    color: countcolor,
    solid: true
  }), children ? myChildren.length : listMap.length)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-tag-group-container"
  }, children ? myChildren : listMap.map(function (elem) {
    return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
      key: "flexi-tag-".concat(elem)
    }, rest), elem);
  })));
};
exports.TagGroup = TagGroup;
TagGroup.defaultProps = {
  block: false,
  color: _theme.FlexTheme.PrimaryColor,
  round: true,
  height: 30,
  autocolor: false
};
TagGroup.propTypes = {
  block: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  round: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  list: _propTypes["default"].any,
  autocolor: _propTypes["default"].bool
};